import { useState } from "react"

import type { ThemeValues } from "@/domains/theme/types"

import { copyToClipboard } from "../copy-to-clipboard"

type ThemeExportModalProps = {
  currentValues: ThemeValues
  onClose: () => void
}

export const ThemeExportModal = ({ currentValues, onClose }: ThemeExportModalProps) => {
  const [copied, setCopied] = useState(false)

  const generateCSSVariables = () => {
    const lines = Object.entries(currentValues)
      .map(([name, value]) => `  --${name}: ${value};`)
      .join("\n")

    return `:root {\n${lines}\n}`
  }

  const cssCode = generateCSSVariables()

  const handleCopy = async () => {
    await copyToClipboard(cssCode)
    setCopied(true)
    setTimeout(() => setCopied(false), 2000)
  }

  return (
    <div className="fixed inset-0 z-50 flex items-center justify-center bg-black bg-opacity-50">
      <div className="bg-p400 w-full max-w-2xl rounded-lg p-6">
        <div className="mb-4 flex items-center justify-between">
          <h3 className="text-t100 text-lg font-semibold">Export Theme CSS</h3>
          <button onClick={onClose} className="hover:text-t100 text-t300">
            ✕
          </button>
        </div>

        <p className="text-t200 mb-4 text-sm">
          Copy these CSS variables to share your theme. Paste them in the Import modal to apply the theme.
        </p>

        {/* CSS Code Display */}
        <div className="relative mb-4">
          <pre className="text-t200 bg-p400 border-p400-light max-h-96 overflow-auto rounded border p-4 font-mono text-sm">
            {cssCode}
          </pre>
          <button
            onClick={handleCopy}
            className="text-t100 absolute right-2 top-2 rounded bg-primary-700 px-3 py-1 text-sm transition-colors hover:bg-primary-600"
          >
            {copied ? "✓ Copied!" : "📋 Copy"}
          </button>
        </div>

        {/* Action Buttons */}
        <div className="flex justify-end gap-2">
          <button onClick={onClose} className="text-t100 bg-p400 hover:bg-p400-light rounded px-4 py-2 text-sm">
            Close
          </button>
        </div>
      </div>
    </div>
  )
}
